import { MouseEventHandler } from 'react';

import { Button, Flex, Text } from '@spotify-internal/encore-web';
import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';

import styles from './NoWorkspaceState.module.css';

export const NoWorkspaceState = ({
  onCreateWorkspace,
  onUseDifferentAccount,
  loading,
}: {
  onCreateWorkspace: MouseEventHandler<HTMLButtonElement>;
  onUseDifferentAccount?: MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
}) => {
  const { enabled: freeEmailSignupEnabled } = useFeatureFlag<{
    enabled: boolean;
  }>('signup-free-email', { enabled: false });

  return (
    <Flex
      className={styles.root}
      direction="column"
      alignItems="center"
      gap="tighter"
    >
      <Text as="h1" variant="titleLarge">
        You&apos;re not in a workspace yet
      </Text>
      <Text as="p" variant="bodyMedium" semanticColor="textSubdued">
        {freeEmailSignupEnabled
          ? 'Create a workspace, or ask a teammate to invite you.'
          : 'Create a workspace with your work email, or ask a teammate to invite you.'}
      </Text>
      <Flex
        className={styles.actions}
        direction="column"
        alignItems="center"
        gap="tighter-2"
      >
        <Button
          variant="primary"
          colorSet="inverted"
          size="large"
          fullWidth
          data-testid="create-workspace-button"
          onClick={onCreateWorkspace}
         data-track-source-anchor="c30934a9ca;;high">
          Create workspace
        </Button>
        {onUseDifferentAccount && (
          <>
            <Text as="p" variant="bodySmall" semanticColor="textSubdued">
              Signed in with the wrong account?
            </Text>
            <Button
              variant="tertiary"
              size="small"
              semanticColor="textBase"
              data-testid="use-different-account-button"
              onClick={onUseDifferentAccount}
              disabled={loading}
              isLoading={loading}
              loadingAriaLabel="Authenticating"
             data-track-source-anchor="416ded6a30">
              Use a different account
            </Button>
          </>
        )}
      </Flex>
    </Flex>
  );
};
